import firebase_app from "../config";
import { getFirestore,  query, where, collection, getDocs } from "firebase/firestore";

export default async function getByLikes(id){
    const db = getFirestore(firebase_app)
    const collectionRef = collection(db, "mesh");
    const q = query(collectionRef, where("love", "array-contains", id));
 

    const querySnapshot = await getDocs(q);
    
    const z = []
    querySnapshot.forEach((doc) => z.push({...doc.data(),id:doc.id}));
    return z
}